import axios from "axios";
import { Price } from "./Price";
import { CashEqRegex, FixedIncomePrices, IPriceHistory } from "../shared/Consts";

interface IPastPrice {
    from:number
    to:number
    price:number
}

const DAY = 24*3600*1000
export default class Prices {
    private _prices : Record<string,Price> = {}
    private _history : Record<string,IPastPrice[]> = {}

    static _i : Prices
    static get i(){
        if (!this._i) this._i = new Prices()
        return this._i
    }

    constructor(){
        for(const id in FixedIncomePrices) {
            this._prices[id] = new Price(FixedIncomePrices[id])
        }
        if (typeof(window) != "undefined") (window as any).prices = this
    }

    get(id:string) { 
        if (id in this._prices) return this._prices[id]

        const fixed = id.match(CashEqRegex)
        if (fixed) {
            const [_,type,currency] = fixed
            this._prices[id] = new Price(FixedIncomePrices[`${type}.${currency}`])
            return this._prices[id]
        }
        return null
    }

    get USD2CAD(){return this.get("USD")!.price }
    get CASH(){return this.get("CASH")! }
    get tickers(){return Object.keys(this._prices)}

    async load(tickers:string[], host:string="") {
        const missing = ["USD",...tickers].filter(ticker => !Price.isCashEq(ticker) && !this.get(ticker))
        if (missing.length) {
            const {data} = await axios.get(host + "/1/prices/" + missing.join(",") + ",")
            for(const id in data){
                this._prices[id] = new Price(data[id])
            }

            const {data:history} = await axios.get(host + "/1/pricehistory/" + missing.join(",") + ",")
            for(const id in history){
                this._history[id] = this._pastPrice(history[id])
            }
        }
    }

    async update(price:Price){
        this._prices[price.id] = price
    }

    private _pastPrice(price:IPriceHistory){
        const ret:IPastPrice[] = []
        for(const date in price.history){
            const d = new Date(date+"T20:00:00Z").getTime()
            ret.push({from:d-DAY, to:d, price:price.history[date]})
        }
        ret.sort((l,r) => l.from - r.from)
        for(var i=0; i<ret.length-1; i++) {
            ret[i].to = ret[i+1].from-1
        }
        return ret
    }

    getHistoricPrice(ticker:string, date:Date){
        const time = date.getTime()
        const history = this._history[ticker]
        if (!history || history.length==0) return this.get(ticker)?.price || 0
        for(var i=history.length-1; i>=0; i--) {
            if (history[i].from<=time) return history[i].price
        }
        return history[0].price
    }
}